<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mUBQdg/tc-custom/9780802199492.jpg?1709153016568" alt="This image is the cover for the book Old Flames, The Inspector Troy Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Old Flames, The Inspector Troy Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>Scotland Yard’s Inspector Troy returns in a Cold War spy thriller hailed as “stylish, sophisticated, suspenseful . . . A fictional tour de force” (Patrick Anderson, </b><b><i>The Washington Post</i></b><b>).</b><br/>  <br/> In April 1956, at the height of the Cold War, Khrushchev and Bulganin, leaders of the Soviet Union, are in Britain on an official visit. Chief Inspector Troy of Scotland Yard is assigned to be Khrushchev’s bodyguard and to spy on him. Soon after, a Royal Navy diver is found dead and mutilated beyond recognition in Portsmouth Harbor. Troy embarks on an investigation that takes him to the rotten heart of MI6, to the distant days of his childhood, and into the dangerous arms of an old flame.<br/>  <br/> “If Troy is the character at the heart of this novel, its soul is England as it was during the Cold War years, a country fueled by paranoia and espionage, overrun with agents and counter-agents, caught up, as Troy says, in ‘an age that specialized in thinking the unthinkable.’” —Anne Stephenson, <i>USA Today</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Lawton
      </h2>
      
      <p class="authorDescription body article">John Lawton is the author of ten novels, including <I>Second Violin</I>, <I>Flesh Wounds</I>, and <I>Bluffing Mr. Churchill</I>. His thriller <I>Black Out</I> won a WH Smith Fresh Talent Award, <I>A Little White Death</I> was named a New York Times&#160;Notable Book, and his latest novel <I>A Lily of the Field</I> was named one of the best thrillers of the year by Marilyn Stasio of the<I> New York Times</I>. At the moment he lives in Derbyshire, England, but can often be found (or lost) elsewhere.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?12903ba9